<template>
  <div>
    <el-dialog :title="title"
               :visible.sync="openStatus"
               :width="width == '' ? '100%' : width + 'px'"
               @close="doClose"
               @open="doOpen"
               :show="openStatus">
      <div id="previewid"
           v-show="mp4show"></div>
      <div id="mp3"
           v-show="mp3show"></div>
      <div id="pdf"
           v-show="pdfshow">
        <!-- <p class="arrow2">
                    <span @click="changePdfPage(0)" :class="{ grey: currentPage == 1 }">上一页</span>
                    {{ currentPage }} / {{ pageCount }}
                    <span @click="changePdfPage(1)" :class="{ grey: currentPage == pageCount }">下一页</span>
                </p> -->
        <p>
          <pdf :src="pdfsrc"
               :page="currentPage"
               @num-pages="pageCount = $event"
               @page-loaded="currentPage = $event"></pdf>
        </p>
        <p class="arrow2"
           style="text-algin:center">
          <span @click="changePdfPage(0)"
                :class="{ grey: currentPage == 1 }">上一页</span>
          {{ currentPage }} / {{ pageCount }}
          <span @click="changePdfPage(1)"
                :class="{ grey: currentPage == pageCount }">下一页</span>
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Player from 'xgplayer';
import Music from 'xgplayer-music';
import pdf from 'vue-pdf';
export default {
  name: 'Template',
  components: {
    pdf
  },
  props: {
    prerurl: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '预览'
    },
    filetype: {
      type: String,
      default: '.mp4'
    }
  },
  data () {
    return {
      Player: null,
      openStatus: this.show,
      Music: null,
      pdfsrc: '',
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      numPages: 1,
      activeIndex: 0,
      mp3show: false,
      mp4show: false,
      pdfshow: false
    };
  },
  methods: {
    doOpen () { },
    doClose () {
      this.openStatus = false
      this.$emit('dialogData', false);
    },
    initPlayer (url) {
      this.Player = new Player({
        id: 'previewid',
        autoplay: true,
        volume: 0.3,
        url: url,
        playsinline: false,
        lastPlayTimeHideDelay: 2,
        'x5-video-player-type': 'h5',
        'x5-video-orientation': 'portraint',
        width: '100%',
        fitVideoSize: 'auto',
        playbackRate: [0.5, 0.75, 1.0, 1.25, 1.5, 2.0, 3.0]
      });
    },
    initPlayerMp3 (url) {
      this.Music = new Music({
        id: 'mp3',
        url: [
          {
            src: url,
            name: this.title,
            poster: '/image/icon/mp3.png'
          }
        ],
        volume: 0.8,
        width: '100%'
        // height: 50
      });
      this.Music.prev();
    },
    destroy () {
      this.Player.destroy();
    },
    destroymp3 () {
      this.Music.destroy();
    },
    /**PDF */
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage (val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    // pdf加载时
    loadPdfHandler (e) {
      this.currentPage = 1; // 加载的时候先加载第一页
    }
  },
  watch: {
    show (val) {
      this.openStatus = val;
      if (val) {
        this.$nextTick(() => {
          if (this.filetype == '.mp4') {
            this.mp3show = false;
            this.mp4show = true;
            this.pdfshow = false;
            this.initPlayer(this.prerurl, 0);
          } else if (this.filetype == '.mp3') {
            this.mp3show = true;
            this.mp4show = false;
            this.pdfshow = false;
            this.initPlayerMp3(this.prerurl);
          } else if (this.filetype == '.pdf') {
            this.mp3show = false;
            this.mp4show = false;
            this.pdfshow = true;
            this.pdfsrc = this.prerurl;
            this.loadPdfHandler();
          }
        });
      } else {
        if (this.filetype == '.mp4') {
          this.destroy();
        } else if (this.filetype == '.mp3') {
          this.destroymp3();
        }
      }
    }
  }
};
</script>
<style>
.arrow2 {
    color: #000;
    text-align: center;
}
.arrow2 span {
    cursor: pointer;
}
#mp3 {
    background-color: rgb(168, 168, 168);
}
#previewid {
    max-height: 600px;
}
</style>
